import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, TextField, Switch, FormControlLabel, Chip, Avatar } from '@mui/material';
import { Edit, Person } from '@mui/icons-material';
import { useAppData } from '../../../../../../context/AppDataContext';
import AppSelect from '../../../../../../components/AppInput/AppSelect';
import taskContributorServices from '../../taskContributorServices';
import { useAlert } from '../../../../../../context/AlertContext';

const ContributorBadge = ({ taskId, addContributorCallBack,removeContributorCallBack }) => {
    const [dialogStatus, setDialogStatus] = useState(false);
    const [notify, setNotify] = useState(false);
    const [remark, setRemark] = useState("");
    const [inputUser,setInputUser] = useState(null);
    const { userDD,getDDDataById } = useAppData();
    const {AppAlert} = useAlert();


    const [contributorList,setContributorList] = useState([]);
    const getContributorlist = () =>{
        taskContributorServices.getByTaskId(taskId).then(res=>{
            setContributorList(res.data)
        }).catch(error=>{

        })
    }

    useEffect(()=>{
        getContributorlist();
    },[taskId])


    const addContributor = () =>{
        if(inputUser !== null){
            let payload = {
                taskId:taskId,
                contributorId:inputUser.value,
            }
            taskContributorServices.save(payload).then(res=>{
                getContributorlist();
                AppAlert(res.msg);
                if (addContributorCallBack) {
                    addContributorCallBack({
                        contributorId: inputUser.value,
                        notify: notify,
                        remark: remark
                    });
                }
            }).catch(error=>{
                AppAlert(error.msg,"error");
            })
        }
    }

    const removeContributor = (contributor) =>{
        taskContributorServices.remove(contributor.id).then(res=>{
            getContributorlist();
            AppAlert(res.msg);
            console.log(res);
            if (removeContributorCallBack) {
                    removeContributorCallBack({
                        contributorId: contributor.contributorId,
                        notify: 0,
                    });
                    
                }

            
        }).catch(error=>{
            AppAlert(error.msg,"error");
        })
    }

    const handleUpdate = () => {
        addContributor();
        
        setDialogStatus(false);
        setRemark("");
    };

    return (
        <>
            <div>
                
                {contributorList.length === 0  && "No Contributor Assigned"}
                {contributorList?.map(contributor=>
                    <Chip 
                        avatar={<Avatar sx={{ width: 24, height: 24 }}><Person fontSize="small" /></Avatar>}
                        label={getDDDataById(userDD, contributor.contributorId)?.label}
                        onDelete={removeContributorCallBack ? ()=>removeContributor(contributor) :null}
                    />
                )}
                 {addContributorCallBack && <button className='btn btn-link' onClick={()=>setDialogStatus(true)}>Add Contributor</button> }
            </div>
            

            {addContributorCallBack && (
                <Dialog
                    open={dialogStatus}
                    onClose={() => setDialogStatus(false)}
                    fullWidth={true}
                    maxWidth="xs"
                >
                    <div className='p-3 fw-bold border-bottom'>Add Contributor</div>
                    <DialogContent>
                        <div className='row mt-2'>
                            <div className='col-md-12'>
                                {/* User Selection */}
                                <AppSelect 
                                    options={userDD}
                                    value={inputUser}
                                    setValue={setInputUser}
                                    label="Select Contributor"
                                />
                                {/* Remark */}
                                <TextField
                                    fullWidth
                                    multiline
                                    rows={2}
                                    label="Handover Note / Remark"
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                    margin="normal"
                                    placeholder="Optional note for the new assignee"
                                />

                                {/* Notification Toggle */}
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={notify}
                                            onChange={(e) => setNotify(e.target.checked)}
                                        />
                                    }
                                    label="Notify contributor via Email"
                                />
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions className="p-3">
                        <button className='btn btn-light' onClick={() => setDialogStatus(false)}>Cancel</button>
                        <button className='btn btn-primary' onClick={handleUpdate}>Add Contributor</button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
};

export default ContributorBadge;